import { ExternalIcon } from "@lifesg/react-icons/external";

const ExternalLinkIcon = (props: { className: string }): JSX.Element => <ExternalIcon className={props.className} />;

export default ExternalLinkIcon;
